import { fetchWrapper } from 'API/authentification/fetch-wrapper';
import { getAppGatewayEndpoint } from 'core/default-endpoint-url';
import type {
    ResolverJobResponse,
    ResolverJobResults,
    ResolverJobStatus,
} from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';

const RESOLVER_BRIDGE_BASE_URL = `${getAppGatewayEndpoint()}/resolver`;

const defaultParams = {
    basePath: '',
    endpoint: '',
};

export const resolverBridgeApi = {
    createJob(payload: any): Promise<ResolverJobResponse> {
        return fetchWrapper({
            ...defaultParams,
            targetUrl: `${RESOLVER_BRIDGE_BASE_URL}/jobs`,
            method: 'POST',
            body: payload,
        });
    },
    getJobStatus(job_id?: string): Promise<ResolverJobStatus> {
        return fetchWrapper({
            ...defaultParams,
            targetUrl: `${RESOLVER_BRIDGE_BASE_URL}/jobs/${job_id}/status`,
        });
    },
    getJobResults(job_id: string): Promise<ResolverJobResults> {
        return fetchWrapper({
            ...defaultParams,
            targetUrl: `${RESOLVER_BRIDGE_BASE_URL}/jobs/${job_id}/results`,
        });
    },
};
